"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCustomFieldOptions = exports.useAppliedFilters = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _utils = require("../utils");
const _excluded = ["value"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const useCustomFieldOptions = (fields, searchFields) => _react.default.useMemo(() => {
  if (!fields) {
    return [];
  }
  const newFields = (searchFields !== null && searchFields !== void 0 ? searchFields : []).filter(searchField => !fields.some(({
    tagKey,
    value
  }) => tagKey === searchField.tagKey && value === searchField.value));
  const concatedFields = fields.concat(newFields);
  return concatedFields.reduce((accum, _ref) => {
    let {
        value
      } = _ref,
      current = (0, _objectWithoutProperties2.default)(_ref, _excluded);
    const existingItem = accum.find(item => item.tagKey === current.tagKey);
    if (existingItem) {
      existingItem.values.push(value);
      return accum;
    }
    return [...accum, _objectSpread(_objectSpread({}, current), {}, {
      values: [value]
    })];
  }, []);
}, [fields, searchFields]);
exports.useCustomFieldOptions = useCustomFieldOptions;
const useAppliedFilters = (value, options) => {
  return _react.default.useMemo(() => {
    if (!value.length) {
      return [];
    }
    if (!options.length) {
      return [];
    }
    return (0, _utils.toCustomFilters)(value[0].values, options);
  }, [value, options]);
};
exports.useAppliedFilters = useAppliedFilters;
//# sourceMappingURL=filters.js.map